import { render, staticRenderFns } from "./MatchContest.vue?vue&type=template&id=6b3640e0&scoped=true&"
import script from "./MatchContest.vue?vue&type=script&lang=js&"
export * from "./MatchContest.vue?vue&type=script&lang=js&"
import style0 from "./MatchContest.vue?vue&type=style&index=0&id=6b3640e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3640e0",
  null
  
)

export default component.exports